import React from 'react';

export interface StripItem {
  v: number | string;
  k: string;
  /** secondary note — a percentage, a caveat */
  p?: string;
  cls?: 'visited' | 'gold' | 'bad';
}

/** Numbers-only strip row — value · label · note. The one renderer behind every
 *  funnel/stat strip in the portal (same component as ui/campaign-portal). No charts. */
const NumberStrip: React.FC<{ items: StripItem[]; className?: string }> = ({ items, className = '' }) => (
  <div className={`flex flex-wrap items-baseline gap-y-2 ${className}`}>
    {items.map(({ v, k, p, cls }, i) => (
      <span
        key={k}
        className={`flex items-baseline gap-1.5 px-4 first:pl-0 ${i > 0 ? 'border-l-[1.5px] border-dotted border-sketch' : ''}`}
      >
        <span className={`num font-bold ${
          cls === 'visited' ? 'text-forest text-lg'
            : cls === 'gold' ? 'text-gold text-lg'
              : cls === 'bad' ? 'text-brick text-sm'
                : 'text-[17px]'
        }`}>{v}</span>
        <span className={`text-xs ${
          cls === 'visited' ? 'text-forest font-semibold'
            : cls === 'gold' ? 'text-amber-ink font-semibold'
              : cls === 'bad' ? 'text-brick'
                : 'text-graphite'
        }`}>{k}</span>
        {p && <span className="num text-[11.5px] text-graphite">{p}</span>}
      </span>
    ))}
  </div>
);

export default NumberStrip;
